import http from "../../http-common";

const createMerchProduct = async (merchProductData) => {
  return await http
    .post("/admin/merch-products", merchProductData)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const updateMerchProduct = async (merchProductId, merchProductData) => {
  return await http
    .put(`/admin/merch-products/${merchProductId}`, merchProductData)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const uploadMerchProductImage = async (merchProductId, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return await http
    .post(
      `/admin/merch-products/${merchProductId}/image`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getAllMerchProducts = async () => {
  return await http
    .get("/admin/merch-products")
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const generateMerchProductImage = async ({
  content,
  count,
  referenceFiles = [],
}) => {
  const formData = new FormData();
  formData.append("content", content);
  formData.append("count", String(count));
  referenceFiles.slice(0, 2).forEach((file) => {
    formData.append("referenceImages", file);
  });
  return await http
    .post("/admin/merch-products/generate-image", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const generateMerchProductKeywords = async ({
  name,
  description,
  type,
  keywords,
}) => {
  return await http
    .post("/admin/merch-products/generate-keywords", {
      name,
      description,
      type,
      keywords,
    })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

export default {
  createMerchProduct,
  updateMerchProduct,
  uploadMerchProductImage,
  getAllMerchProducts,
  generateMerchProductImage,
  generateMerchProductKeywords,
}; 